/* tslint:disable */
/* eslint-disable */
/**
 * Presentation API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SectionFetchedData } from './SectionFetchedData';
import {
    SectionFetchedDataFromJSON,
    SectionFetchedDataFromJSONTyped,
    SectionFetchedDataToJSON,
    SectionFetchedDataToJSONTyped,
} from './SectionFetchedData';

/**
 * 
 * @export
 * @interface FetchAllSectionsDataResponseDto
 */
export interface FetchAllSectionsDataResponseDto {
    /**
     * 
     * @type {Array<SectionFetchedData>}
     * @memberof FetchAllSectionsDataResponseDto
     */
    fetchedData: Array<SectionFetchedData>;
}

/**
 * Check if a given object implements the FetchAllSectionsDataResponseDto interface.
 */
export function instanceOfFetchAllSectionsDataResponseDto(value: object): value is FetchAllSectionsDataResponseDto {
    if (!('fetchedData' in value) || value['fetchedData'] === undefined) return false;
    return true;
}

export function FetchAllSectionsDataResponseDtoFromJSON(json: any): FetchAllSectionsDataResponseDto {
    return FetchAllSectionsDataResponseDtoFromJSONTyped(json, false);
}

export function FetchAllSectionsDataResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FetchAllSectionsDataResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fetchedData': ((json['fetchedData'] as Array<any>).map(SectionFetchedDataFromJSON)),
    };
}

export function FetchAllSectionsDataResponseDtoToJSON(json: any): FetchAllSectionsDataResponseDto {
    return FetchAllSectionsDataResponseDtoToJSONTyped(json, false);
}

export function FetchAllSectionsDataResponseDtoToJSONTyped(value?: FetchAllSectionsDataResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fetchedData': ((value['fetchedData'] as Array<any>).map(SectionFetchedDataToJSON)),
    };
}

